module.exports = __webpack_public_path__ + "static/background.038dd007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/fullscreen/background.jpg
// module id = 485
// module chunks = 114276838955818